import { render, staticRenderFns } from "./KolkinSharesGraph.vue?vue&type=template&id=6ae10d68&scoped=true"
import script from "./KolkinSharesGraph.vue?vue&type=script&lang=js"
export * from "./KolkinSharesGraph.vue?vue&type=script&lang=js"
import style0 from "./KolkinSharesGraph.vue?vue&type=style&index=0&id=6ae10d68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae10d68",
  null
  
)

export default component.exports